export function getReyesImageSources(characterId: string): {
  webp: string
  png: string
} {
  const baseId = characterId.endsWith('-video')
    ? characterId.replace('-video', '')
    : characterId

  return {
    webp: `/reyes/${baseId}.webp`,
    png: `/reyes/${baseId}.png`
  }
}
